export default class CreateShareholderRequest {
    public companyId: number | null = null;

    public personId: number | null = null;
}